export default __webpack_public_path__ + "static/media/ed_7.6c912417.mp3";